<template>
  <v-card
    flat
    tile
    color="transparent"
    width="100%"
  >
    <v-img
      contain
      height="150"
      :src="step.image"
    ></v-img>

    <v-card-text>
      <v-row
        justify="center"
        align="center"
        class="text-center flex-column"
      >
        <div
          :class="MIXIN_SETUP_UI.title"
          class="my-3 font-weight-bold"
          :style="{ color: details.color}"
        >
          {{ step.title }}
        </div>

        <div>{{ step.caption }}</div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";

  export default {
    name: 'ResellerStepCard',
    data: () => ({
      show: false,
      details: {}
    }),
    props: {
      step: { type: Object }
    },
    watch: {
      resellerDetails: {
        handler: function(value) {
          if (value) {
            this.details = value.howItWorks;
            this.show = true;
          }
        },
        immediate: true
      }
    },
    computed: {
      resellerDetails: function() {
        return RESELLER_EVENT_BUS.resellerDetails
          ? RESELLER_EVENT_BUS.resellerDetails.section
          : null;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>